export default "__VITE_ASSET__C0ATEnD6__"